import Actions             from "../../../model/constant/actions"
import ReducerUtils        from "../../../utils/ReducerUtils"
import ObjectUtils         from "../../../utils/ObjectUtils"
import GoogleCampaignStats from "../../../model/Store/Statistics/CampaignStats"

const retrieveCampaignsStatsForAccount = (state,action) =>{
  if (state[action.accountId]){
    var newState = {}
    for (let stat of state[action.accountId] ){ newState[stat.CampaignAWId+stat.Day] = stat }
    for (let stat of action.stats            ){ newState[stat.CampaignAWId+stat.Day] = stat }
    return {...state, [action.accountId] : ObjectUtils.getObjectValues(newState)}
  }
  return {...state,[action.accountId] : action.stats}
}
interface BingCampaignStatsByAccount{
  [accountId:number] : GoogleCampaignStats[]
}
export const CampaignsStats = ReducerUtils.createReducer<BingCampaignStatsByAccount>({},{
  [Actions.RETRIEVE_AW_CAMPAIGNS_STATS_FOR_ACCOUNTID] : retrieveCampaignsStatsForAccount
})
